import type { CoverLetterDto } from "@reactive-resume/dto";

import { axios } from "@/client/libs/axios";

export const findCoverLetterById = async (data: { id: string }) => {
  const response = await axios.get<CoverLetterDto>(`/cover-letter/${data.id}`);
  return response.data;
};
